import React from 'react';
import { Grid, GridProps, makeStyles } from '@material-ui/core';

// Ersatz für das entfernte `variant="gridItem"` (siehe VARIANT_STYLES in InfoCard):
// Karte als Flex-Spalte mit voller Höhe, der Inhalt (CardContent) wächst mit.
// Die neuen Karten (EntityInfoCard) nutzen `Card` aus @backstage/ui, das selbst weder Rand noch
// Schatten mitbringt. Diese werden hier wie bei den MUI-Karten (Paper) ergänzt.
const useStretchItemStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '& > *': {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      '@media print': { height: 'auto' },
    },
    '& > * > .MuiCardContent-root': { flex: 1 },
    '& > [class*="bui-Card"]': {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[1],
    },
  },
  // Trennlinie unter der Überschrift (bei den MUI-InfoCards war dort ein Divider).
  headerDivider: {
    '& > [class*="bui-Card"] > [class*="bui-CardHeader"]': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    '& > [class*="bui-Card"] > [class*="bui-CardBody"]': {
      paddingTop: theme.spacing(2),
    },
  },
}));

export type StretchItemProps = GridProps & {
  /** Zeigt eine Trennlinie unter der Kartenüberschrift (für Karten ohne eigene Linie). */
  headerDivider?: boolean;
};

/** `Grid item`, dessen Karte die volle Höhe der Zeile ausfüllt und das Kachel-Aussehen erhält. */
export const StretchItem = ({ headerDivider, className, ...props }: StretchItemProps) => {
  const classes = useStretchItemStyles();
  const classNames = [classes.root, headerDivider ? classes.headerDivider : '', className].filter(Boolean).join(' ');
  return <Grid item className={classNames} {...props} />;
};
